<template>
  <!--  房地产-->
  <div class="waiceng">
    <el-menu
        :default-active="dictDataType"
        class="el-menu-vertical-demo"
        :unique-opened="true"
        @select="selectChange">
      <el-submenu index="投资总额">
        <template slot="title">
          <span><em class="redIcon"></em><i class="write">投资总额</i></span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_total_investment">房地产开发投资完成额:累计值</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="施工面积">
        <template slot="title">
          <span><em class="redIcon"></em><i class="write">施工面积</i></span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_construction_buy">本年购置土地面积:累计值</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_construction_house">房屋施工面积:累计值</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_construction_residence">房屋施工面积:住宅:累计值</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="新开工面积">
        <template slot="title">
          <span><em class="redIcon"></em><i class="write">新开工面积</i></span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_construction_new_house">房屋新开工面积:累计值</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_construction_new_residence">房屋新开工面积:住宅:累计值</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="销售面积">
        <template slot="title">
          <span><em class="redIcon"></em><i class="write">销售面积</i></span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_sale_house">商品房销售面积:累计值</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_sale_residence">商品房销售面积:住宅:累计值</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="资金来源">
        <template slot="title">
          <span><em class="redIcon"></em><i class="write">资金来源</i></span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_capital_loan">房地产开发资金来源:国内贷款:累计值</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_capital_total">房地产开发资金来源:合计:累计同比</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="竣工面积">
        <template slot="title">
          <span><em class="redIcon"></em><i class="write">竣工面积</i></span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_completed">房屋竣工面积:累计值</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="房价指数">
        <template slot="title">
          <span><em class="redIcon"></em><i class="write">房价指数</i></span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_house_price">70个大中城市新建商品住宅价格指数:当月同比</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="待售面积">
        <template slot="title">
          <span><em class="redIcon"></em><i class="write">待售面积</i></span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_wait_sale_house">商品房待售面积:累计值</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_wait_sale_residence">商品房待售面积:住宅:累计值</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
    <Detail class="detail" :dictDataType="dictDataType"></Detail>
  </div>
</template>

<script>
import Detail from '@/components/macroscopic/detail'

export default {
  name: "economics",
  components: {
    Detail
  },
  data() {
    return {
      dictDataType: 'issue_macroscopic_total_investment',
    }
  },
  created() {
  },
  methods: {
    /**
     * 切换详情
     * @param index
     */
    selectChange(index) {
      this.dictDataType = index;
    }
  },
}
</script>

<style scoped lang="less">
.detail {

}

.el-menu {
  color: #222222;
  display: inline-block;
  vertical-align: top;
  width: 236px;
  min-height: 688px;
  box-shadow: 0px 2px 10px 0px rgb(183 183 183 / 50%);
}

.redIcon {
  display: inline-block;
  width: 4px;
  height: 4px;
  background: #D3131A;
  border-radius: 1px;
  font-style: normal;
  margin-right: 15px;
  vertical-align: middle;
}

.write {
  font-style: normal;
  vertical-align: middle;
  display: inline-block
}
</style>
